export type LanguageEntry = {
  code: string
  slug: string
  isCurrentPage?: boolean
}

export const LANGUAGE_OPTIONS = [
  { label: 'English (EN)', value: 'en' },
  { label: 'Spanish (ES)', value: 'es' },
]

// Endonyms — each language is named in its own language, so a Spanish speaker
// sees "Español" rather than "Spanish".
export const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  es: 'Español',
}
